@app.controller 'PagesController', (PageService, $stateParams, $state, AnalyticsService, MetadataService, ExperimentService, ModalService, $filter, $rootScope, navService, $scope, $location, $timeout, authenticationService) ->

  handleSuccess = (data) =>
    # For promotions with landing pages instead of redirects
    # /promo will be reloaded with the discount_id parameter /promo?discount_id=DISCOUNTID
    discountIdFromURL = $location.search().discount_id
    if data.isPromotion && data.discountId && !discountIdFromURL
      $location.search('discount_id', data.discountId)
      # Timeout to prevent a redirect loop in Safari.
      $timeout(->
        location.reload(true)
      ,1)
      return

    @content = data
    firstComponent = @content.components[0]
    firstComponentType = firstComponent.componentType
    firstComponentNav = firstComponent.meta.nav
    if ((firstComponentType == 'hero' && firstComponent.meta.items[0]?.content.heroType != 'collection') || firstComponentNav == 'ghost')
      navService.setState('nav-ghost')
    if $state.currentUser && (firstComponentType == 'banner' && firstComponent.meta.items[0]?.content.type == 'Madlib')
      navService.setState('nav-ghost')

    # TODO Allow the page editor to set SEO description and keywords for a page
    title = $filter('titlecase')(@content.title)
    description = @content.shortDescription
    keywords = @content.title
    image = @content.components[0].meta.items[0].content.image
    canonical = $state.href($state.current.name)
    MetadataService.set
      title: title
      description: description
      keywords: keywords
      canonical: canonical
      # Hacky, but no disaster if it is wrong
      sousVideTargeted: _.contains(title.toLowerCase(), 'sous vide')

      og:
        title: "#{title} | ChefSteps"
        image: image
        url: canonical
        description: description
      twitter:
        title: "#{title} | ChefSteps"
        image: image

    # Set exportUrl
    exportContent = {}
    angular.copy @content, exportContent
    # Don't export id or shortDescription
    delete exportContent.id
    delete exportContent.shortDescription

    data = JSON.stringify(@content)
    blob = new Blob([ data ], { type : 'application/json' })
    @exportUrl = (window.URL || window.webkitURL).createObjectURL( blob )
    @exportTitle = "#{@content.title}_#{Date.now()}.json"

    @pageRequiresPremium = (_.find _this.content.components, (c) -> c.meta.showTo == "non-premium")?

  handleError = (error) ->
    console.log 'Error getting page: ', error

  pageId = $state.current.views.main.data?.pageId || $stateParams.id || "joule-#{$stateParams.slug}"
  pageId = 'new-premium-lp' if pageId == 'premium' && $state.currentUser?.premium
  pageId = pageId.toLowerCase()

  # CHEFWEB-426, help out bad search engines
  $state.go 'main.home' if pageId == "!"

  PageService.show {id: pageId}, handleSuccess, handleError

  @moveUp = (index) =>
    if index > 0
      # Remove the item at index
      removed = @content.components[index]
      @content.components.splice(index, 1)

      # Insert item
      @content.components.splice(index-1, 0, removed)
      setPositions()

  @moveDown = (index) ->
    numComponents = @content.components.length
    if index < (numComponents - 1)
      # Remove the item at index
      removed = @content.components[index]
      @content.components.splice(index, 1)

      # Insert item
      @content.components.splice(index + 1, 0, removed)
      setPositions()

  setPositions = =>
    angular.forEach @content.components, (component, index) ->
      component.position = index

  @save = =>
    # Dont save shortDescription until we fix the api to accept shortDescription mass assignment
    delete @content.shortDescription
    delete @content.isPromotion
    delete @content.redirectPath
    delete @content.discountId
    handleUpdateSuccess = (data) =>
      console.log 'saved data: ', data
      @content = data
      @editing = false

    handleUpdateError = ->
      console.log 'Error getting page.'

    PageService.update {id: $stateParams.id, page: @content}, handleUpdateSuccess, handleUpdateError

  @cancel = =>
    @editing = false
    $state.go $state.current, {}, reload: true

  @maybeShowComponent = (showTo) =>
    showComponent
    switch showTo
      when 'everyone'
        showComponent = true
      when 'premium'
        showComponent = @currentUser?.premium
      when 'non-premium'
        showComponent = !@currentUser?.premium
      when undefined
        showComponent = true
    return showComponent

  @showComponent = (component) =>
    return true if @editing

    return false if component._destroy == '1'

    if !! component.meta?.experiment?.experimentName
      e = component.meta.experiment
      return false if ! ExperimentService.isInVariation(e.experimentName, e.variationName, e.variationCount)

    @maybeShowComponent(component.meta.showTo)

  @currentUser = $state.currentUser

  $rootScope.$on '$stateChangeSuccess', =>
    @currentUser = $state.currentUser
    true

  $scope.$watch 'page.importFile', (newValue) =>
    if newValue
      # Mark the old page components to be removed
      oldComponents = @content.components.map (component) -> _.extend(component,{_destroy: '1'})
      # Set the imported components to have the page as their parent
      fixedstring = decodeURIComponent(escape(newValue))
      newPageContent = JSON.parse(fixedstring)
      console.log 'newPageContent: ', newPageContent
      importComponents = newPageContent.components.map (component) -> _.extend(component,{componentParentId: pageId, id: null})

      # Set the page components
      # Dos not persist until admin presses save
      @content.components = _.union oldComponents, importComponents

  if $state.current.name == 'home'
    AnalyticsService.track 'Viewed New Homepage'

  $rootScope.$on '$stateChangeStart', (event, toState, toParams, fromState, fromParams) ->
    if fromState.name == 'main.classes' && toState.name == 'main.activity' && ! toParams['context']
      # Add context param to class/collection link
      toParams['context'] = fromParams.id
      event.preventDefault()

      # Require sign-in/up - this will resolve right away if already signed in
      ModalService.open('signup',
        source: 'freeClass'
        extraText: "A Free Account Is Required To View This Class"
      ).then(
        -> $state.go 'main.activity', toParams
      )


  # Redirect old CS style hash URLs like:
  # https://www.chefsteps.com/classes/poutine#/finding-perfect-french-fry-potatoes to
  # https://www.chefsteps.com/activities/finding-perfect-french-fry-potatoes?context=poutine
  if $state.current.name == 'main.classes' && $location.hash()[0] == '/'
    slug = $location.hash()[1..]
    $state.go 'main.activity', {slug: slug, context: $state.params['id']}

  this
